import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import IconItem from "modules/common/icon/IconItem";
import corner1 from "assets/img/illustrations/corner-2.png";
import Background from "modules/common/Background";

function TotalTalkTime({ tagWiseCall }) {

  const colorPicker = [
    "warning",
    "info",
    "success",
    "danger",
    "primary",
    "secondary",
    "warning",
  ];

  return (
    <div>
      <div className="" style={{display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"2rem"}}>
        {Object.keys(tagWiseCall).map((stat, index) => (
          <div key={tagWiseCall[stat].id} className="flex-1">
            <Card className="h-100">
              <Card.Body>
                <Background
                  image={corner1}
                  style={{
                    borderTopRightRadius: "0.375rem",
                    borderBottomRightRadius: "0.375rem",
                  }}
                />
                <Row className="flex-between-center">
                  <Col className="d-lg-block flex-between-center me-n4">
                    <div className="d-flex flex-row align-items-center">
                      <IconItem
                        tag="div"
                        icon="phone"
                        bg={`soft-${colorPicker[index]}`}
                        color={colorPicker[index]}
                        size="lg"
                        iconClass="fs--2"
                        className="me-2 shadow-none"
                      />
                      <h6 className="mb-2 text-900">
                        {stat.replaceAll("_", " ").charAt(0).toUpperCase() +
                          stat.replaceAll("_", " ").slice(1).toLowerCase()}
                      </h6>
                    </div>
                    <h4 className="fs-3 ps-5 fw-normal text-700 mb-0">
                      {tagWiseCall[stat]}
                    </h4>
                  </Col>
                  <Col xs="auto" className="h-100"></Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TotalTalkTime;
